import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'primary' | 'outline' | 'danger';
  size?: 'sm' | 'md' | 'lg';
}
export function Button({
  className = '',
  variant = 'default',
  size = 'md',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    default: 'bg-[#f6f8fa] text-[#24292f] border border-[rgba(27,31,36,0.15)] hover:bg-[#f3f4f6] shadow-sm',
    primary: 'bg-[#1f883d] text-white border border-[rgba(27,31,36,0.15)] hover:bg-[#1a7f37] shadow-sm',
    outline: 'bg-transparent text-[#0969da] border border-[rgba(27,31,36,0.15)] hover:bg-[#f6f8fa] hover:underline',
    danger: 'bg-[#f6f8fa] text-[#cf222e] border border-[rgba(27,31,36,0.15)] hover:bg-[#ffebe9] hover:text-[#a40e26]'
  };
  const sizes = {
    sm: 'px-3 py-1 text-xs',
    md: 'px-4 py-1.5 text-sm',
    lg: 'px-5 py-2.5 text-base'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-231">
      {children}
    </button>;
}